export default __webpack_public_path__ + "static/media/connectWhite.ee6a1332.svg";